export interface FirebaseTokenInterface {
  firebaseToken?: string;
  userId?: string;
}
